export default {
  root: ({ props }) => ({
    class: [
      'inline-flex items-center justify-center align-top gap-2',
      'p-3 m-0 rounded-md dark:border',
      {
        'bg-info-100/70 dark:bg-info-500/20': props.severity == 'info',
        'bg-green-100/70 dark:bg-green-500/20': props.severity == 'success',
        'bg-warning-100/70 dark:bg-warning-500/20': props.severity == 'warn',
        'bg-danger-100/70 dark:bg-danger-500/20': props.severity == 'error'
      },
      {
        'dark:border-info-400': props.severity == 'info',
        'dark:border-green-400': props.severity == 'success',
        'dark:border-warning-400': props.severity == 'warn',
        'dark:border-danger-400': props.severity == 'error'
      },
      {
        'text-info-700 dark:text-info-300': props.severity == 'info',
        'text-green-700 dark:text-green-300': props.severity == 'success',
        'text-warning-700 dark:text-warning-300': props.severity == 'warn',
        'text-danger-700 dark:text-danger-300': props.severity == 'error'
      }
    ]
  }),
  icon: {
    class: 'text-base'
  },
  text: {
    class: [
      // Font and Text
      'text-base leading-none',
      'font-medium'
    ]
  }
};
